import { ResponsiveText } from '../DataCard.style';

type Props = {
  isNetworkInfo: boolean;
  enableMapViewHideOption: boolean;
  cssProps: any;
  planName: string;
};

export const PlanIndicator = ({
  enableMapViewHideOption,
  cssProps,
  planName,
  isNetworkInfo,
}: Props) => {
  if (!isNetworkInfo) return null;

  return (
    <ResponsiveText
      css={{ textAlign: 'center' }}
      cssProps={cssProps}
      fontWeight={enableMapViewHideOption ? 'regular' : 'medium'}
    >
      {planName}
    </ResponsiveText>
  );
};
